import { createAction, createAsyncAction } from "typesafe-actions";

import type { FetchError } from "../../../types";
import type {
    ExcludeListsDuplicateOpportunitiesResponseDto,
    ListRecommendationType,
    NotRelevantResultsModalPayload,
    OpportunityListModal,
    OpportunityListType,
    WebsiteSearchResult,
} from "../types";

export const fetchOpportunityListsAsync = createAsyncAction(
    "@@si/opportunities/FETCH_LISTS_START",
    "@@si/opportunities/FETCH_LISTS_SUCCESS",
    "@@si/opportunities/FETCH_LISTS_FAILURE",
)<void, OpportunityListType[], FetchError>();

export const createOpportunityListAsync = createAsyncAction(
    "@@si/opportunities/CREATE_LIST_START",
    "@@si/opportunities/CREATE_LIST_SUCCESS",
    "@@si/opportunities/CREATE_LIST_FAILURE",
)<void, OpportunityListType, FetchError>();

export const updateOpportunityListAsync = createAsyncAction(
    "@@si/opportunities/UPDATE_LIST_START",
    "@@si/opportunities/UPDATE_LIST_SUCCESS",
    "@@si/opportunities/UPDATE_LIST_FAILURE",
)<void, OpportunityListType, FetchError>();

export const updateOpportunityList = createAction("@@si/opportunities/UPDATE_LIST")<OpportunityListType>();

export const updateListOpportunitiesAsync = createAsyncAction(
    "@@si/opportunities/UPDATE_LIST_OPPORTUNITIES_START",
    "@@si/opportunities/UPDATE_LIST_OPPORTUNITIES_SUCCESS",
    "@@si/opportunities/UPDATE_LIST_OPPORTUNITIES_FAILURE",
)<void, Partial<OpportunityListType>, FetchError>();

export const deleteOpportunityListAsync = createAsyncAction(
    "@@si/opportunities/DELETE_LIST_START",
    "@@si/opportunities/DELETE_LIST_SUCCESS",
    "@@si/opportunities/DELETE_LIST_FAILURE",
)<void, OpportunityListType["opportunityListId"], FetchError>();

export const fetchExcludeListsDuplicatesAsync = createAsyncAction(
    "@@si/opportunities/FETCH_EXCLUDE_LISTS_DUPLICATES_START",
    "@@si/opportunities/FETCH_EXCLUDE_LISTS_DUPLICATES_SUCCESS",
    "@@si/opportunities/FETCH_EXCLUDE_LISTS_DUPLICATES_FAILURE",
)<void, ExcludeListsDuplicateOpportunitiesResponseDto, FetchError>();

export const fetchListRecommendationsAsync = createAsyncAction(
    "@@si/opportunities/FETCH_LIST_RECOMMENDATIONS_START",
    "@@si/opportunities/FETCH_LIST_RECOMMENDATIONS_SUCCESS",
    "@@si/opportunities/FETCH_LIST_RECOMMENDATIONS_FAILURE",
)<void, ListRecommendationType[], FetchError>();

export const dismissRecommendationAsync = createAsyncAction(
    "@@si/opportunities/DISMISS_RECOMMENDATION_START",
    "@@si/opportunities/DISMISS_RECOMMENDATION_SUCCESS",
    "@@si/opportunities/DISMISS_RECOMMENDATION_FAILURE",
)<string, string, FetchError>();

export const removeRecommendedDomains = createAction("@@si/opportunities/REMOVE_RECOMMENDED_DOMAINS")<
    readonly string[]
>();

export const removeOpportunityListAction = createAction("@@si/opportunity-lists/remove-deleted-list")<
    OpportunityListType["opportunityListId"]
>();

export const searchForWebsites = createAsyncAction(
    "@@si/opportunities/SEARCH_FOR_WEBSITES_START",
    "@@si/opportunities/SEARCH_FOR_WEBSITES_SUCCESS",
    "@@si/opportunities/SEARCH_FOR_WEBSITES_FAILURE",
)<void, WebsiteSearchResult[], FetchError>();

export const toggleOpportunityListModal = createAction(
    "@@si/opportunities/TOGGLE_LIST_MODAL",
    (isOpen: boolean, list?: OpportunityListType) => ({ isOpen, list } as OpportunityListModal),
)();

export const toggleExcludeListsDuplicatesModal = createAction(
    "@@si/opportunities/TOGGLE_EXCLUDE_LISTS_DUPLICATES_MODAL",
)<boolean>();

export const removeOpportunitiesFromList = createAsyncAction(
    "@@si/opportunities/REMOVE_OPPORTUNITIES_START",
    "@@si/opportunities/REMOVE_OPPORTUNITIES_SUCCESS",
    "@@si/opportunities/REMOVE_OPPORTUNITIES_FAILURE",
)<void, string[], FetchError>();

export const downloadListTableExcelAsync = createAsyncAction(
    "@@si/opportunities/DOWNLOAD_LIST_TABLE_EXCEL_START",
    "@@si/opportunities/DOWNLOAD_LIST_TABLE_EXCEL_SUCCESS",
    "@@si/opportunities/DOWNLOAD_LIST_TABLE_EXCEL_FAILURE",
)<void, void, FetchError>();

export const toggleRecommendationsBarAction = createAction("@@si/opportunities/TOGGLE_RECOMMENDATIONS_BAR")<boolean>();

export const setSelectedOpportunityListNameAndIdAction = createAction("@@si/opportunities/SET_LIST_NAME_AND_ID")<{
    opportunityListId: string;
    opportunityListName: string;
}>();

export const setOpportunityListIdToShowUpdatedListModal = createAction(
    "@@si/opportunities/SET_OPPORTUNITY_LIST_ID_TO_SHOW_UPDATED_LIST_MODAL",
)<string | undefined>();

export const listRenameModalOpenSetAction = createAction("@@si/opportunity-lists/rename-modal-open-set")<boolean>();
export const listDeleteModalOpenSetAction = createAction("@@si/opportunity-lists/delete-modal-open-set")<boolean>();

export const tableRowsSelectionToggledAction = createAction(
    "@@si/static-lists/table-rows-selection-toggled",
)<boolean>();

export const notRelevantResultsModalPayloadSetAction = createAction(
    "@@si/opportunities/not-relevant-results-modal-payload-set",
)<NotRelevantResultsModalPayload>();

export const setShouldWaitToFiltersFromSavedSearch = createAction(
    "@@si/opportunities/set-should-wait-to-filters-from-save-search",
)<boolean>();
